import { render, staticRenderFns } from "./shipin.vue?vue&type=template&id=1ce26b09&scoped=true"
import script from "./shipin.vue?vue&type=script&lang=js"
export * from "./shipin.vue?vue&type=script&lang=js"
import style0 from "./shipin.vue?vue&type=style&index=0&id=1ce26b09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce26b09",
  null
  
)

export default component.exports